import React from 'react'
import {ProductItem} from './product-item'
import {ParagraphText} from '@thryvlabs/maverick'
import checkIfIncentiveApplies from '../../utils/check-if-incentive-applies'
import {currencyFormat} from '../../utils/currency-format'
import {BC_PLANS, MC_PLANS} from '../../utils/constants'
import {reportingCenterIcon} from '../../assets'

function Container({children, isFragment}) {
  if (isFragment) {
    return <>{children}</>
  }
  return (
    <div
      style={{
        border: '1px solid rgba(0, 0, 0, 0.2)',
        borderRadius: '3px',
        paddingLeft: '10px',
        paddingTop: '3px',
        lineHeight: '10px',
      }}
    >
      {children}
    </div>
  )
}

function ProductSection({
  title,
  products,
  isOld = false,
  isUpgrade,
  eligibleTransitionCenters,
  incentiveCoupon,
  upgradePaymentPreview,
  country,
  orderCouponCodes,
  selectedCentersAndApps,
  isCohort,
  all5PlanPrices = [],
}) {
  const isOneTimeFee = title === 'One Time Fees'

  if (title === 'Software') {
    // Remove alpha seo from centers
    products = products.filter(({code}) => code !== 'seobase-5-thryv-m2m')
    if (!isOld) {
      let isRCBasicExist = products.find(
        item => item.code === 'rc_basic-5-thryv-m2m',
      )
      let updatedProduct = products
      // OOE-UI-EF: `all5PlanPrices` defaults to `[]` but is read as an object
      // with a `centers` array, so any render before the 5.0 price list
      // arrives gave `[].centers` -> undefined -> `.find` threw and the whole
      // cart drawer unmounted into the ErrorBoundary. If we can't resolve the
      // real Reporting Center plan we leave the basic product untouched
      // instead of blanking the sidebar.
      const all5PlanCenters = Array.isArray(all5PlanPrices?.centers)
        ? all5PlanPrices.centers
        : []
      if (isRCBasicExist) {
        let RCPlanDetails = all5PlanCenters.find(({code}) =>
          code?.includes('rc-5'),
        )
        if (RCPlanDetails) {
          updatedProduct = products.map(item => {
            if (item.code === 'rc_basic-5-thryv-m2m') {
              item.code = RCPlanDetails.code
              item.name = RCPlanDetails.name
              item.id = RCPlanDetails.id
              item.icon = reportingCenterIcon
              item['tempLineActionCode'] = 'New'
            }

            return item
          })
        }
      }
      products = updatedProduct
    }
  } else if (title === 'Add-Ons') {
    // Check if alpha seo is present under Centers or Apps
    const isAlphaSeoPresentInState =
      selectedCentersAndApps?.centers?.find(
        ({code}) => code === 'seobase-5-thryv-m2m',
      ) ||
      selectedCentersAndApps?.apps?.find(
        ({code}) => code === 'seobase-5-thryv-m2m',
      )
    // Check if alpha seo is already present under Add-Ons products list
    const isAlphaSeoPresentAsApp = products
      ? products.find(product => product?.code === 'seobase-5-thryv-m2m')
      : null
    // Add alpha seo under apps if not already listed
    if (
      isAlphaSeoPresentInState &&
      !isAlphaSeoPresentAsApp &&
      selectedCentersAndApps
    ) {
      products.push(isAlphaSeoPresentInState)
    }
  }

  // Display MC pro enhanced with the incentive applied
  const formattedProducts = products.map(product => {
    if (product.code === 'mc_pro_enh-5-thryv-m2m') {
      const couponAmount =
        orderCouponCodes?.find(coupon =>
          coupon.appliesToPlans?.includes(product.code),
        )?.discountAmount || 0
      const price = product.amount * (product.quantity || 1) - couponAmount
      return {
        ...product,
        amount: currencyFormat(price, country, true),
      }
    }
    return product
  })

  return (
    <Container isFragment={!isOneTimeFee}>
      <ParagraphText variant="lg" className="font-weight-bold">
        {title}
      </ParagraphText>
      <div className={!isOneTimeFee ? 'ml-2' : ''}>
        {formattedProducts.map(currentItem => {
          const showIncentive =
            !isOld &&
            checkIfIncentiveApplies(
              currentItem,
              isUpgrade,
              eligibleTransitionCenters,
              incentiveCoupon,
            )
          const {code} = currentItem || {}
          const isListingsApp = code === 'app-listings'
          const isBCorMCInCart = selectedCentersAndApps?.centers.some(
            ({code}) => BC_PLANS.includes(code) || MC_PLANS.includes(code),
          )
          return (
            <React.Fragment
              key={!isOld ? currentItem.id : currentItem.id + 'old'}
            >
              <ProductItem
                currentItem={currentItem}
                showIncentive={showIncentive}
                isOneTimeFee={isOneTimeFee}
                upgradePaymentPreview={upgradePaymentPreview}
                incentiveCoupon={incentiveCoupon}
                country={country}
                crossedOut={isListingsApp && isBCorMCInCart}
                isCohort={isCohort}
                orderCouponCodes={orderCouponCodes}
              />
              {currentItem.entitlements?.map(entitlement => (
                <div
                  key={entitlement.code}
                  className="d-flex justify-content-between ml-3"
                >
                  <p style={{color: '#808080', margin: 0}}>
                    {entitlement.name}
                  </p>
                  <p className="mr-2" style={{color: '#808080', margin: 0}}>
                    {entitlement.amount === 0 || !entitlement.amount
                      ? 'Included'
                      : entitlement.amount}
                  </p>
                </div>
              ))}
            </React.Fragment>
          )
        })}
      </div>
    </Container>
  )
}

export {ProductSection}
